import axiosInstance from "../axiosInstance";

export const getLanguages = async () => {
  try {
    const response = await axiosInstance.get("/languages");
    return response.data;
  } catch (error) {
    console.error("Error sending languages data", error);
    throw error;
  }
};
